/**
 * 확신도 × 회피 교차 판정.
 *
 * 확신도 상승에는 전혀 다른 두 가지가 섞여 있다.
 *   (a) 시험받고 실제로 단단해짐 → 회피 0
 *   (b) 방어적으로 굳어버림     → 회피 있음
 * 둘을 같은 문구로 칭찬하면 서비스가 확증편향을 강화하는 도구가 된다.
 *
 * 분기는 debate-lab/src/debate.js 의 것과 같다. 어미만 해요체다.
 */
export function verdict({ convictionStart, convictionEnd, evasions = 0 }) {
  const d = Number(convictionEnd) - Number(convictionStart);

  if (d > 0 && evasions > 0) return `확신은 커졌지만, 답하지 않은 질문이 ${evasions}개 남았어요`;
  if (d <= -10) return "생각이 크게 흔들렸어요";
  if (d < 0) return "조금 물러섰어요";
  if (d === 0) return "확신은 그대로예요";
  if (d < 10) return "조금 더 단단해졌어요";
  return "시험을 통과했어요";
}

/** frame 이 결과 화면의 헤딩과 카드 태그를 가른다. */
export function framing(frame) {
  return frame === "logic"
    ? { heading: "이 기준, 끝까지 가면", sub: "당신 기준을 예외 없이 적용하면 이렇게 돼요." }
    : { heading: "10년 뒤에는", sub: "이 입장이 10년간 관철된 세계를 그려봤어요." };
}

/** 두 배열이 모두 비면 헤딩이 바뀐다. 에러가 아니라 정상 분기다. */
export const hasGaps = (report) =>
  (report?.unanswered?.length ?? 0) > 0 || (report?.thin_evidence?.length ?? 0) > 0;
